var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slider',{attrs:{"color":"secondary","prepend-icon":"opacity","value":_vm.layer.getOpacity(),"min":"0","max":"1","step":"0.01","thumb-label":"","hide-details":""},on:{"input":_vm.onOpacitySliderInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }